export const messages = {
  en: {
    message: {
      hello: 'hello world',
      start: 'Start',
      upcomingEvents: 'Upcoming events:',
      beltGrades: 'Belt grades',
      countries: 'Countries',
      members: 'Members',
      results: 'Results',
      rankings: 'Rankings',
      about: 'About',
      next: 'Next',
      back: 'Back',
      more: 'More',
      searchForNameOrMap: 'Search for name or MAP',
      membersFound: 'members found',
      unknownBeltsFound: ' members with unknown belt grade found.',
      category: 'Category',
      achievements: 'Achievements',
      aboutTitle: 'About the GCO members platform',
      aboutContent: '<p>Starting with 2019, all GCO member information and achievements are available immediately.</p><p>If your data is not correct or an image is out of date, please feel free to tell us: <a href="mailto:office@gcoworld.com">office@gcoworld.com</a></p><p class="light">© 2019 GCOWORLD GmbH</p>',
      cookieInfo: 'This website uses cookies. By continuing to use the website, you agree to the use of cookies. ',
      learnMore: 'Learn more',
      gotIt: 'Got it!',
      fight: 'Fight',
      forms: 'Forms',
      noRankingsFound: 'No rankings found in this category',
      seasonStart: 'Season start',
      clearFilters: 'Clear filters',
      total: 'Total',
      tournaments: 'Tournaments',
      nationalTournaments: 'National tournaments',
      president: 'President',
      officials: 'Officials',
      nationalCoaches: 'National coaches',
      privacy: 'Privacy',
      imprint: 'Imprint',
      systemUpdating: 'We are currently updating the GCO members system. There might be trouble. Thank you for understanding!',
      systemDown: 'The GCO members system is currently not available.<br>Please check back later.',
      noDataAvailable: 'No data available',
      registrationsAvailable: 'Current registrations',
      registrationsSoFar: 'registration(s) so far',
      noResultsInCategory: 'No results in this category',
      furtherParticipants: 'Further participants',
      search: 'Search'
    },
    country: {
      germany: 'Germany'
    }
  },
  de: {
    message: {
      hello: 'Hallo Welt',
      start: 'Start',
      upcomingEvents: 'Die nächsten Events:',
      beltGrades: 'Gürtelgrade',
      countries: 'Länder',
      members: 'Mitglieder',
      results: 'Ergebnisse',
      rankings: 'Ranglisten',
      about: 'Über',
      next: 'Weiter',
      back: 'Zurück',
      more: 'Mehr',
      searchForNameOrMap: 'Nach Name oder MAP suchen',
      membersFound: 'Mitglieder gefunden',
      unknownBeltsFound: ' Mitglieder mit unbekanntem Gürtelgrad gefunden.',
      category: 'Kategorie',
      achievements: 'Erfolge',
      aboutTitle: 'Über das GCO Members Portal',
      aboutContent: '<p>Ab 2019 sind alle GCO Mitglieder Informationen und Erfolge sofort verfügbar.</p><p>Wenn an euren Daten etwas nicht korrekt ist oder ein Bild nicht mehr aktuell ist, gebt uns bitte Bescheid: <a href="mailto:office@gcoworld.com">office@gcoworld.com</a></p><p class="light">© 2019 WKUWORLD GmbH</p>',
      cookieInfo: 'Diese Website verwendet Cookies. Mit der Nutzung diese Angebots stimmen Sie dem zu. ',
      learnMore: 'Mehr erfahren',
      gotIt: 'Alles klar!',
      fight: 'Kampf',
      forms: 'Formen',
      noRankingsFound: 'Für diese Kategorie wurde keine Rangliste gefunden',
      seasonStart: 'Saisonstart',
      clearFilters: 'Filter löschen',
      total: 'Summe',
      tournaments: 'Turniere',
      nationalTournaments: 'Nationale Turniere',
      president: 'Präsident',
      officials: 'Repräsentanten',
      nationalCoaches: 'Nationaltrainer',
      privacy: 'Datenschutz',
      imprint: 'Impressum',
      systemUpdating: 'Wir aktualisieren gerade das GCO Members System. Es kann zu Störungen kommen. Danke für dein Verständnis!',
      systemDown: 'Das GCO Members System ist gerade nicht verfügbar.<br>Bitte schau später wieder vorbei.',
      noDataAvailable: 'Kein Daten verfügbar',
      registrationsAvailable: 'Aktuelle Anmeldungen',
      registrationsSoFar: 'Anmeldung(en) bis jetzt',
      noResultsInCategory: 'Keine Ergebnisse in dieser Kategorie',
      furtherParticipants: 'Weitere Teilnehmer',
      search: 'Suchen'
    },
    country: {
      germany: 'Deutschland'
    }
  },
  it: {
    message: {
      hello: 'Hallo Welt',
      start: 'Inizio',
      upcomingEvents: 'I prossimi eventi:',
      beltGrades: 'Gradi cintura',
      countries: 'Paesi',
      members: 'Membri',
      results: 'Risultati',
      rankings: 'Classifica',
      about: 'Di',
      next: 'Dopo',
      back: 'Indietro',
      more: 'Più',
      searchForNameOrMap: 'Cerca per nome o MAP',
      membersFound: 'membri trovati',
      unknownBeltsFound: ' membri trovati con grado di cintura sconosciuto.',
      category: 'Categoria',
      achievements: 'Successo',
      aboutTitle: 'Informazioni sul portale dei membri GCO',
      aboutContent: '<p>Dal 2019 tutte le informazioni e i risultati dei membri GCO sono immediatamente disponibili.</p><p>Se qualcosa non va con i tuoi dati o un´immagine è scaduta, faccelo sapere: <a href="mailto:office@gcoworld.com">office@gcoworld.com</a></p><p class="light">© 2019 WKUWORLD GmbH</p>',
      cookieInfo: 'Questo sito Web utilizza i cookie. Usando questa offerta, sei d´accordo. ',
      learnMore: 'Saperne di più',
      gotIt: 'Va bene!',
      fight: 'Lotta',
      forms: 'Forma',
      noRankingsFound: 'Nessuna classifica trovata per questa categoria',
      seasonStart: 'Avvio di stagione',
      clearFilters: 'Elimina filtro',
      total: 'Somma',
      tournaments: 'Tornei',
      nationalTournaments: 'Tornei nazionali',
      president: 'Presidente',
      officials: 'Rappresentanti',
      nationalCoaches: 'Allenatore',
      privacy: 'Privacy Policy',
      imprint: 'Impronta',
      systemUpdating: 'Stiamo aggiornando il sistema dei membri di GCO. Può causare disturbi. Grazie per la vostra comprensione!',
      systemDown: 'Il sistema dei membri GCO non è al momento disponibile. <br> Rivedi più tardi.',
      noDataAvailable: 'Nessun dato disponibile',
      registrationsAvailable: 'Registrazioni attuali',
      registrationsSoFar: 'Registrazioni fino ad ora',
      noResultsInCategory: 'Nessun risultato in questa categoria',
      furtherParticipants: 'Altri partecipanti',
      search: 'Ricerca'
    },
    country: {
      germany: 'Deutschland'
    }
  }  
}
